import { getCacheUrlParamValue } from "../utils/api-calls";

export class OfferBookService {
  private static readonly HOST = `${process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : ''}/_api`;

  static async get(currency: Currency): Promise<OfferBook> {
    let data;

    try {
      const response = await fetch(`${OfferBookService.HOST}/currencies/${currency.code}_BRL/orderbook?cache=${getCacheUrlParamValue()}`);
      data = await response.json() as OfferBookResponse;
    } catch {
      data = {};
    }

    return {
      purchase: data?.bids?.map(item => ({ price: item[0], quantity: item[1] })) || [],
      sell: data?.asks?.map(item => ({ price: item[0], quantity: item[1] })) || [],
    } as OfferBook;
  }
}
